import client1 from '../images/client1.png';
import client2 from '../images/client2.png';
import client3 from '../images/client3.png';
import client4 from '../images/client4.png';
import client5 from '../images/client5.png';
import client6 from '../images/client6.png';
import client7 from '../images/client7.png';
import client8 from '../images/client8.png';

export const clients = [client1, client2, client3, client4, client5, client6, client7, client8];